import type { AppInventoryOptionType } from '@openx/types/targeting/appInventory.ts';
import type { InventoryContentOption } from '@openx/types/targeting/inventoryAndContent.ts';
import type { ComparisonType } from '@openx/types/targeting/targetingValuesTypes.ts';
import { comparisonOptions } from '../constants.ts';

export const ifComparisonOptionDoesntExist = (
  value: ComparisonType | null,
  option: InventoryContentOption | AppInventoryOptionType
): boolean => !comparisonOptions[option]?.includes(value);
